export default "__VITE_ASSET__24TZO0Q3__"